import React from 'react';
import { Button } from './ui/button';
import { CheckCircle, ArrowDown } from 'lucide-react';
import { booksData } from '../newMock';

const NewHeroSection = ({ onViewSeriesClick }) => {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 flex items-center justify-center py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        {/* Main Headline */}
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-8">
          {booksData.heroSection.headline}
        </h1>

        {/* Subheadline */}
        <h2 className="text-xl md:text-2xl lg:text-3xl text-blue-700 font-semibold mb-12 max-w-4xl mx-auto leading-relaxed">
          {booksData.heroSection.subheadline}
        </h2>

        {/* Outcome Points */}
        <div className="max-w-3xl mx-auto mb-12">
          <div className="space-y-4">
            {booksData.heroSection.outcomePoints.map((point, index) => (
              <div key={index} className="flex items-start space-x-3 bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                <CheckCircle className="w-6 h-6 text-green-600 mt-0.5 flex-shrink-0" />
                <span className="text-lg text-gray-800 text-left">{point}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Primary CTA */}
        <div className="mb-16">
          <Button
            onClick={onViewSeriesClick}
            size="lg"
            className="bg-gradient-to-r from-blue-600 to-purple-700 hover:from-blue-700 hover:to-purple-800 text-white font-bold py-4 px-8 text-xl rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105"
          >
            View the Marriage 101 Series
          </Button>
        </div>

        {/* Scroll Indicator */}
        <div className="animate-bounce">
          <ArrowDown className="w-6 h-6 text-gray-400 mx-auto" />
          <p className="text-sm text-gray-500 mt-2">Scroll to explore the series</p>
        </div>
      </div>
    </section>
  );
};

export default NewHeroSection;